import { Button } from 'react-bootstrap';
import BinIcon from '../../../components/icon/IconWrapped';
import React, { useCallback } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import appHistory from '../../../app/appHistory';
import { locationSlice } from '../../Location/locationReducer';
import { LOCATION_NAMES } from '../../Location/locationConstants';
import { useDispatch } from 'react-redux';
import { UserStatusCongratulationsButtonsStyled } from './styled/UserStatusCongratulationsButtonsStyled';

interface IUserStatusCongratulationsButtonsProps {
    myStatusButtonVariant?: 'primary' | 'secondary' | 'tertiary',
}

function UserStatusCongratulationsButtons(props: IUserStatusCongratulationsButtonsProps) {
    const { myStatusButtonVariant = 'secondary' } = props;
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();

    const onTradeMoreClickHandler = useCallback((e) => {
        e.preventDefault();
        appHistory.goBack();
    }, []);

    const onShowMyStatusClickHandler = useCallback((e) => {
        appHistory.goBack();
        setTimeout(() => {
            dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.USER_STATUSES }));
        }, 100);
    }, [dispatch]);

    return <UserStatusCongratulationsButtonsStyled>
        <Button variant={'primary'}
                name={'button_primary'}
                onClick={onTradeMoreClickHandler}>
            {getLangPath('user_statuses.controls.trade_more')} <BinIcon name={'IcForward'}/>
        </Button>
        <Button variant={myStatusButtonVariant}
                name={'button_secondary'}
                onClick={onShowMyStatusClickHandler}>
            {getLangPath('user_statuses.controls.my_status')}
        </Button>
    </UserStatusCongratulationsButtonsStyled>;
}

export default UserStatusCongratulationsButtons;
